var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-nav"},[_c('router-link',{attrs:{"to":"/introduce"}},[_vm._v("公司简介")]),_c('router-link',{attrs:{"to":"/case"}},[_vm._v("客户案例")]),_c('router-link',{attrs:{"to":"/classroom"}},[_vm._v("实战课堂")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }